import { useForm } from 'react-hook-form'

import Button from 'src/ui/atoms/Button'
import WrappedInput from 'src/ui/atoms/Input/Wrapped'

import useEsdtToken, { IWipeEsdtToken } from './useEsdtToken'
import { IProject } from '../../useProjectApi'

const WipeToken = ({ project }: { project: IProject }) => {
  const { isLoading, handleToken, isWalletConnected } = useEsdtToken({
    payloadKey: 'esdtWipePayload',
  })

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
  })

  const handleWipe = async (data: IWipeEsdtToken) => {
    await handleToken({
      ...data,
      type: 'wipe',
      network: project.data.network,
      tokenTicker: project.data.detailedTokenTicker,
    })
  }

  return (
    <form
      className="flex flex-col gap-6"
      onSubmit={handleSubmit((data) => handleWipe(data as IWipeEsdtToken))}>
      <div className="grid gap-4">
        <WrappedInput
          placeholder="Address to wipe"
          label="Address to wipe"
          error={errors.addressToFreeze}
          {...register('addressToFreeze', {
            required: 'Required field',
          })}
        />
      </div>
      <Button
        className="self-end"
        size="M"
        name="Freeze"
        disabled={!isValid || !isWalletConnected}
        loading={isLoading}
      />
    </form>
  )
}

export default WipeToken
